import http from '@/plugins/http';

export default (params) => new Promise((res, rej) => {
  http.post('/v3/users/check-email', { email: params.email, token: params.token })
    .then((response) => {
      res(response.data);
    }, (response) => {
      rej(response.response.data.detail);
    });
});
